import { Tooltip } from "@mui/material";
import { useAdminResetPasswordAction } from "@features/Users/useAdminResetPasswordAction";
import { Form } from "@shared/components/Form";
import { SubmitButton } from "@avenue-8/sidekick-ui";
import { useCallback } from "react";

type Props = {
  isLoading: boolean;
  userEmail: string;
  fullWidth?: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
};

export const AdminResetUserPassword = (props: Props) => {
  const { isLoading, userEmail, fullWidth, disabled, disabledTooltip } =
    props;
  const { resetPassword, isPending } = useAdminResetPasswordAction();

  const handleResetPasswordSubmit: React.FormEventHandler<HTMLFormElement> =
    useCallback(
      (e) => {
        e.preventDefault();
        resetPassword({ email: userEmail });
      },
      [resetPassword, userEmail]
    );

  const tooltipTitle = disabled
    ? (disabledTooltip ?? "This user can't reset their password.")
    : "A temporary password will be generated. You can copy and send it to the user.";

  return (
    <Form
      aria-disabled={isLoading || isPending}
      onSubmit={handleResetPasswordSubmit}
    >
      <Tooltip title={tooltipTitle}>
        <span>
          <SubmitButton
            variant="outlined"
            isLoading={isPending}
            size={fullWidth ? "medium" : "small"}
            fullWidth={fullWidth}
            loadingText="Resetting..."
            disabled={disabled}
          >
            Reset password
          </SubmitButton>
        </span>
      </Tooltip>
    </Form>
  );
};
